import {BriefPanelName, PanelTypeEnum, Unit, VAxisType} from '@balrog/component/common';
import {ProfileInterface} from './interface/profile.interface';
import { AccessPermissionEnum } from '@balrog/core/model/const';

export class WindsterProfile implements ProfileInterface {
    statuses = {
        WTC_STAT_HAMULEC_FAZOWY: {title: 'Hamulec fazowy'},
        WTC_STAT_REZYSTORY: {title: 'Rezystory'},
    };
    // alarmy
    alarms = {
        WTC_ALARM_BLAD_PAMIECY_NASTAW: {title: 'Błąd pamięci nastaw'},
        WTC_ALARM_BLAD_PAMIECY_PROGRAMU: {title: 'Błąd pamięci programu'},
        WTC_ALARM_AWARIA_CZUNIKA_T1: {title: 'Awaria czujnika T1'},
        WTC_ALARM_PRZEGRZANIE_T1: {title: 'Przegrzanie czujnika T1'},
        WTC_ALARM_AWARIA_CZUNIKA_T2: {title: 'Awaria czujnika T2'},
        WTC_ALARM_PRZEGRZANIE_T2: {title: 'Przegrzanie czujnika T2'},
        WTC_ALARM_WYSOKA_TEMP_RADIATORA: {title: 'Wysoka temp. radiatora'},
        WTC_ALARM_WYSOKA_TEMP_GENERATORA: {title: 'Wysoka temp. generatora'},
        WTC_ALARM_WYSOKIE_NAPIECIE_SYSTEMOWE: {title: 'Wysokie napięcie systemowe'},
        WTC_ALARM_NISKIE_NAPIECIE_SYSTEMOWE: {title: 'Niskie napięcie systemowe'},
        WTC_ALARM_WYSOKIE_NAPIECIE_DC: {title: 'Wysokie napięcie DC'},
        WTC_ALARM_BLAD_POMIARU_NAPIECA_AC: {title: 'Błąd pomiaru napięcia AC turbiny'},
        WTC_ALARM_ASYMETRIA_FAZ_NAPIECIE: {title: 'Alarm asymetria napięcia faz'},
        WTC_ALARM_ASYMETRIA_FAZ_PRAD: {title: 'Alarm asymetria prądu faz'},
        WTC_ALARM_WYSOKIE_NAPIECIE_INVERTER: {title: 'Alarm wysokie napięcie inwertera'},
        WTC_ALARM_BLAD_INVERTERA: {title: 'Alarm błąd inwertera'}
    };

    briefPanel = {
        name: BriefPanelName.ELEKTROMIZ_WINDSTER
    };

    dashBoard = {
        panelType: PanelTypeEnum.ELEKTROMIZ_WINDSTER
    };

    historyBoard = {
        title: 'Moc [W]',
        content: [
            {
                paramId: 'WTC_VAL_GRZALKA_MOC',
                unit: Unit.W,
                vAxisType: VAxisType.POWER_W.valueOf(),
            },
            {
                paramId: 'WTC_VAL_TURBINA_ZUZYCIE_MOCY',
                unit: Unit.W,
                vAxisType: VAxisType.POWER_W.valueOf(),
            },
            {
                paramId: 'WTC_VAL_INVERTER_MOC',
                unit: Unit.W,
                vAxisType: VAxisType.POWER_W.valueOf(),
            },
            {
                paramId: 'WTC_VAL_TURBINA_RPM',
                unit: Unit.RPM,
                vAxisType: VAxisType.RPM.valueOf(),
            },
            {
                paramId: 'WTC_VAL_WIATR_KIERUNEK',
                unit: Unit.DEGREE,
                vAxisType: VAxisType.DEGREE.valueOf(),
            },
            {
                paramId: 'WTC_VAL_WIATR_PREDKOSC',
                unit: Unit.MS,
                vAxisType: VAxisType.MS.valueOf(),
            },
            {
                paramId: 'WTC_VAL_INVERTER_NAPIECIE_DC',
                unit: Unit.V,
                vAxisType: VAxisType.V.valueOf(),
            },
            {
                paramId: 'WTC_VAL_NAPIECIE_SYSTEMOWE',
                unit: Unit.V,
                vAxisType: VAxisType.V.valueOf(),
            },
            {
                paramId: 'WTC_VAL_NAPIECIE_AC',
                unit: Unit.V,
                vAxisType: VAxisType.V.valueOf(),
            },
            {
                paramId: 'WTC_VAL_NAPIECIE_DC_TURBINA',
                unit: Unit.V,
                vAxisType: VAxisType.V.valueOf(),
            },
        ]
    };

    listBoard = {
        title: 'Konfiguracja',
        content: [
        {
            paramId: 'WERSJA_STEROWNIKA',
            unit: Unit.NONE,
            step: 0.01,
        },
        {
            title: 'Odczyty Mocy',
            type: 'MENU',
            content: [
                {
                    paramId: 'WTC_VAL_GRZALKA_MOC',
                    unit: Unit.W,
                },
                {
                    paramId: 'WTC_VAL_TURBINA_MOC',
                    readPermission: AccessPermissionEnum.INSTALLER.valueOf(),
                    unit: Unit.W,
                },
                {
                    paramId: 'WTC_VAL_TURBINA_ZUZYCIE_MOCY',
                    unit: Unit.W,
                },
                {
                    paramId: 'WTC_VAL_INVERTER_MOC',
                    unit: Unit.W,
                },
                {
                    paramId: 'WTC_VAL_INVERTER_NASTAWA_MOC',
                    readPermission: AccessPermissionEnum.INSTALLER.valueOf(),
                    unit: Unit.W,
                },
            ]},
                {
                    title: 'Odczyty DC',
                    type: 'MENU',
                    content: [
                {
                    paramId: 'WTC_VAL_NAPIECIE_DC_TURBINA',
                    unit: Unit.V,
                    step: 0.1,
                },
                {
                    paramId: 'WTC_VAL_INVERTER_NAPIECIE_DC',
                    unit: Unit.V,
                    step: 0.1,
                },
                {
                    paramId: 'WTC_VAL_INVERTER_NAPIECIE_L1',
                    unit: Unit.V,
                    step: 0.1,
                },
                {
                    paramId: 'WTC_VAL_INVERTER_NAPIECIE_L2',
                    unit: Unit.V,
                    step: 0.1,
                },
                {
                    paramId: 'WTC_VAL_INVERTER_NAPIECIE_L3',
                    unit: Unit.V,
                    step: 0.1,
                },
                {
                    paramId: 'WTC_VAL_NAPIECIE_SYSTEMOWE',
                    unit: Unit.V,
                    step: 0.1,
                },
                {
                    paramId: 'WTC_GONDOLA_VAL_NAPIECIE_BATERII',
                    unit: Unit.V,
                    step: 0.1,
                },
                {
                    paramId: 'WTC_VAL_LICZNIKI_MOC_CALKOWITA_INWERTER',
                    unit: Unit.KWH,
                    step: 0.1,
                },
                ]},
                {
                    title: 'Odczyty AC',
                    type: 'MENU',
                    content: [
                    {
                        paramId: 'WTC_VAL_NAPIECIE_AC',
                        unit: Unit.V,
                        step:1,
                    },
                    {
                        paramId: 'WTC_VAL_NAPIECIE_AC_L1',
                        unit: Unit.V,
                        step:1,
                    },
                    {
                        paramId: 'WTC_VAL_NAPIECIE_AC_L2',
                        unit: Unit.V,
                        step:1,
                    },
                    {
                        paramId: 'WTC_VAL_NAPIECIE_AC_L3',
                        unit: Unit.V,
                        step:1,
                    },
                    {
                        paramId: 'WTC_VAL_PRAD_AC_L1',
                        unit: Unit.A,
                        step:1,
                    },
                    {
                        paramId: 'WTC_VAL_PRAD_AC_L2',
                        unit: Unit.A,
                        step:1,
                    },
                    {
                        paramId: 'WTC_VAL_PRAD_AC_L3',
                        unit: Unit.A,
                        step:1,
                    },
                ]},
                {
                    title: 'Odczyty Temperatury',
                    type: 'MENU',
                    content: [
                    {
                        paramId: 'WTC_VAL_TEMPERATURA_T1',
                        unit: Unit.C,
                        step:1,
                    },
                    {
                        paramId: 'WTC_VAL_TEMPERATURA_T2',
                        unit: Unit.C,
                        step:1,
                    },
                ]},
                {
                    title: 'Odczyty wiatr',
                    type: 'MENU',
                    content: [
                        {
                            paramId: 'WTC_VAL_WIATR_PREDKOSC',
                            unit: Unit.MS,
                            step: 0.1,
                        },
                        {
                            paramId: 'WTC_VAL_WIATR_KIERUNEK',
                            unit: Unit.DEGREE,
                            step: 0.1,
                        },
                        {
                            title: 'Historia wiatru',
                            type: 'MENU',
                            content: this.CreateWindHistory()
                        },
                ]},
                {
                    title: 'Dane historyczne',
                    type: 'MENU',
                    content: [
                    {
                        paramId: 'WTC_VAL_LICZNIKI_PEAK_MOCY',
                        unit: Unit.W,
                        step:1,
                    },
                    {
                        paramId: 'WTC_VAL_LICZNIKI_MOC_CALKOWITA',
                        unit: Unit.KWH,
                        step:0.001,
                    },
                    {
                        paramId: 'WTC_VAL_LICZNIKI_MOC_CALKOWITA_REZYSTOR',
                        unit: Unit.KWH,
                        step:0.001,
                    },
                    {
                        paramId: 'WTC_VAL_LICZNIKI_MOC_CALKOWITA_INWERTER',
                        unit: Unit.KWH,
                        step:0.001,
                    },
                    {
                        paramId: 'WTC_VAL_LICZNIKI_PEAK_WIATR',
                        step:0.01,
                        unit: Unit.MS,
                    },
                    {
                        paramId: 'WTC_VAL_LICZNIKI_PEAK_NAPIECIE_AC',
                        unit: Unit.V,
                        step:0.1,
                    },
                    {
                        paramId: 'WTC_VAL_LICZNIKI_PEAK_PRAD_AC',
                        unit: Unit.A,
                        step:0.1,
                    },
                    {
                        paramId: 'WTC_VAL_LICZNIKI_PEAK_NAPIECIE_DC',
                        unit: Unit.V,
                        step:0.1,
                    },
                    {
                        paramId: 'WTC_VAL_LICZNIKI_PEAK_OBROTY',
                        unit: Unit.RPM,
                    },
                ]},
                {
                    paramId: 'WTC_VAL_STAN_STEROWNIKA',
                    type: 'ITEM-SELECT',
                    options: [{value: '0', name: 'Błąd'}, {value: '1', name: 'Praca'}, {value: '2', name: 'Zatrzymanie ręczne'}, {value: '3', name: 'Zatrzymanie automatyczne'}]
                },
                {
                    paramId: 'WTC_VAL_GRZALKA_PWM',
                    unit: Unit.PERCENTAGE,
                    readPermission: AccessPermissionEnum.INSTALLER.valueOf(),
                },
                {
                    paramId: 'WTC_VAL_TURBINA_RPM',
                    unit: Unit.RPM,
                },
    ]};

    scheduleBoard = null;

    CreateWindHistory()
    {
        const content = []
        const points = 21
        for(let i = 0; i < points; i++)
        {
            const pointTab =
            {
                paramId: 'WTC_VAL_HISTORIA_WIATRU_P'+i,
                unit: Unit.SEC,
            }
            content.push(pointTab)
        }
        return content
    }

    CreatePowerCurveRpm()
    {
        const content = []
        const powerPointsAmount = 12
        for(let i = 1; i <= powerPointsAmount; i++)
        {
            const rpmPointDesc =
            {
                paramId: 'WTC_SETP_KRZYWA_MOCY_RPM_RPM_P'+i,
                unit: Unit.RPM,
            }
            content.push(rpmPointDesc)
            const powerPointDesc =
            {
                paramId: 'WTC_SETP_KRZYWA_MOCY_RPM_W_P'+i,
                unit: Unit.W,
            }
            content.push(powerPointDesc)
        }
        return content
    }

    CreatePowerCurveAc()
    {
        const content = []
        const powerPointsAmount = 12
        for(let i = 1; i <= powerPointsAmount; i++)
        {
            const rpmPointDesc =
            {
                paramId: 'WTC_SETP_KRZYWA_MOCY_AC_V_P'+i,
                unit: Unit.V,
                step: 0.1,
            }
            content.push(rpmPointDesc)
            const powerPointDesc =
            {
                paramId: 'WTC_SETP_KRZYWA_MOCY_AC_W_P'+i,
                unit: Unit.W,
            }
            content.push(powerPointDesc)
        }
        return content
    }

    CreateVoltageCurve()
    {
        const content = []
        const voltagePointsAmount = 6
        for(let i = 1; i <= voltagePointsAmount; i++)
        {
            const rpmPointDesc =
            {
                paramId: 'WTC_SETP_KRZYWA_NAPIECIA_V_P'+i,
                unit: Unit.V,
                step: 0.1,
            }
            content.push(rpmPointDesc)
            const powerPointDesc =
            {
                paramId: 'WTC_SETP_KRZYWA_NAPIECIA_A_P'+i,
                unit: Unit.A,
                step: 0.1,
            }
            content.push(powerPointDesc)
        }
        return content
    }

    CreateCommonRelaySettings(relayId, content)
    {
        const d2 =
        {
            paramId: 'WTC_SETP_PRZEKAZNIK_STEROWANIE_RL' + relayId,
            type: 'ITEM-SELECT',
            options: [
                {value: '0', name: 'Temperatura T1'},
                {value: '1', name: 'Temperatura T2'},
                {value: '2', name: 'Napięcie AC'},
                {value: '3', name: 'Napięcie DC'}]
        }
        content.push(d2)
        const d3 =
        {
            paramId: 'WTC_SETP_PRZEKAZNIK_TEMP_WLACZENIA_RL' + relayId,
            unit: Unit.C,
            step: 0.1,
        }
        content.push(d3)
        const d4 =
        {
            paramId: 'WTC_SETP_PRZEKAZNIK_TEMP_WYLACZENIA_RL' + relayId,
            unit: Unit.C,
            step: 0.1,
        }
        content.push(d4)
        const d5 =
        {
            paramId: 'WTC_SETP_PRZEKAZNIK_V_WLACZENIA_RL' + relayId,
            unit: Unit.V,
            step: 0.1,
        }
        content.push(d5)
        const d6 =
        {
            paramId: 'WTC_SETP_PRZEKAZNIK_V_WYLACZENIA_RL' + relayId,
            unit: Unit.V,
            step: 0.1,
        }
        content.push(d6)
    }
    CreateRelaySettings(relayId)
    {
        const content = []
        switch(relayId)
        {
            case 1:
            case 2:
            {
                const d1 =
                {
                    paramId: 'WTC_SETP_PRZEKAZNIK_FUNKCJA_RL' + relayId,
                    type: 'ITEM-SELECT',
                    options: [{value: '1', name: 'Gondola'}, {value: '2', name: 'Użytkownik'}]
                }
                content.push(d1)
            }break;
            case 3:
            case 4:
            {
                const d1 =
                {
                    paramId: 'WTC_SETP_PRZEKAZNIK_FUNKCJA_RL' + relayId,
                    type: 'ITEM-SELECT',
                    options: [{value: '3', name: 'Hamowanie'}, {value: '2', name: 'Użytkownik'}]
                }
                content.push(d1)
            }break;
            case 5:
            {
                const d1 =
                {
                    paramId: 'WTC_SETP_PRZEKAZNIK_FUNKCJA_RL' + relayId,
                    type: 'ITEM-SELECT',
                    options: [{value: '2', name: 'Użytkownik'}]
                }
                content.push(d1)
            }break;
        }
        this.CreateCommonRelaySettings(relayId, content)
        return content
    }
}
